// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c577f0e3","453":"be6f8b4c","455":"38136e64","977":"7238689c"}[chunkId] + ".chunk.js";
};